import React from 'react'
import PropTypes from 'prop-types'

class Counter extends React.Component {
  constructor(props) {
    super(props)
    const dateTime =
      typeof props.dateTime == 'string' ? new Date(props.dateTime).getTime() : props.dateTime
    this.state = {
      time: 0,
      date: dateTime,
    }
    this.startTimer()
  }
  startTimer() {
    const { countdown } = this.props
    this.timer = setInterval(
      () =>
        this.setState({
          time: countdown ? this.state.date - Date.now() : Date.now() - this.state.date,
        }),
      100
    )
  }
  stopTimer() {
    clearInterval(this.timer)
  }
  componentWillUnmount() {
    this.stopTimer()
  }

  UNSAFE_componentWillReceiveProps(props) {
    const dateTime =
      typeof props.dateTime == 'string' ? new Date(props.dateTime).getTime() : props.dateTime
    this.setState({
      time: 0,
      date: dateTime,
    })
  }

  textTime(number) {
    return number < 10 ? '0' + number : number
  }

  render() {
    const { className } = this.props
    const totalSeconds = Math.abs(Math.floor(this.state.time / 1000))
    const minutes = Math.floor(totalSeconds / 60) % 60
    const hours = Math.floor(totalSeconds / 3600)
    const seconds = totalSeconds % 60
    return (
      <div className={className}>
        {this.textTime(hours) + ' : ' + this.textTime(minutes) + ' : ' + this.textTime(seconds)}
      </div>
    )
  }
}

Counter.propTypes = {
  dateTime: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  countdown: PropTypes.bool,
  className: PropTypes.string,
}

export default Counter
